import { render, staticRenderFns } from "./AutomatedViewsBtn.vue?vue&type=template&id=3f572928"
import script from "./AutomatedViewsBtn.vue?vue&type=script&lang=js"
export * from "./AutomatedViewsBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports